import ListView from "../singleton/list-view";

export default {

    getAll: ListView.getAll.bind(ListView),

    get: ListView.get.bind(ListView),

    create: ListView.create.bind(ListView),

    update: ListView.update.bind(ListView),

    delete: ListView.delete.bind(ListView),

    clone: ListView.clone.bind(ListView),

    getByListId: ListView.getByListId.bind(ListView),

    getByEntityId: ListView.getByEntityId.bind(ListView),

    getByRelationId: ListView.getByRelationId.bind(ListView)

}